<header class="modal__header">
  <h3 *ngIf="options.title" [ngStyle]="options.color && { color: 'black' }">{{ options.title }}</h3>
  <a class="button button--transparent modal__button--close" (click)="close(true)">
    <i class="icon icon-ui-close--sm" [ngStyle]="options.color && { 'background-color': '#' + options.color.color }"></i>
  </a>
</header>
<div class="modal__content">
  <div *ngIf="options.message" class="modal__text" [internalInnerHtml]="options.message" [userEventSource]="userEventSource"></div>
</div>
<div class="modal__footer" *ngIf="options.buttons?.length">
  <div
    class="button__group"
    [ngClass]="{
      'button__group--right': !options.isWideButtonGroup,
      'button__group--stretch': options.isWideButtonGroup,
      'button__group--full-width': options.isWideButtonGroup
    }"
  >
    <a
      class="button"
      *ngFor="let button of options.buttons"
      (click)="onButtonClick(button, $event)"
      [ngClass]="button.buttonClass"
      [airButtonLoading]="!!button.isLoading"
      [style.background-color]="options.color && button.isPrimary && '#' + options.color.color"
      [style.color]="options.color && !button.isPrimary && '#' + options.color.color"
    >
      <span>{{ button.text }}</span>
    </a>
  </div>
</div>
